import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-controlchat-desktop',
  templateUrl: './controlchat-desktop.component.html',
  styleUrl: './controlchat-desktop.component.scss'
})
export class ControlchatDesktopComponent implements OnInit, OnDestroy {
  private readonly desktopLoginKey = 'controlchat_desktop_last_login';

  constructor(private auth: AuthService, private router: Router) {}

  ngOnInit() {
    document.body.classList.add('controlchat-desktop');
    localStorage.setItem('controlchat_desktop_mode', '1');
    if (this.auth.isLoggedIn() && !this.isLoggedInToday()) {
      this.auth.logout();
      this.router.navigate(['/login'], { queryParams: { desktop: '1' } });
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('controlchat-desktop');
  }

  private isLoggedInToday(): boolean {
    const raw = localStorage.getItem(this.desktopLoginKey);
    if (!raw) return false;
    const today = new Date().toISOString().slice(0, 10);
    return raw === today;
  }
}
